<ng-container *ngTemplateOutlet="activeTemplate"></ng-container>

<ng-template #defaultLoading></ng-template>
<ng-template #defaultError></ng-template>
<ng-template #defaultData></ng-template>
